define('views/root/split_pano',[
    'backbone',
    'views/_base/baseview',
    'text!views/root/split_pano.html',
    'fancybox',
    'views/shared/list/icon_list'
], function(Backbone, BaseView, Template, Fancybox, IconListComponent){
    'use strict';

    return BaseView.extend({
        tagName  : 'div',
        className: 'pano-inner-container',
        template : _.template(Template),
        isRender : true,
        needsAuth: false,
        events   : {
            'click .js-consumer-btn': 'goToConsumerLanding',
            'click .js-enterprise-btn': 'goToEnterpriseLanding'
        },

        initialize: function(options){
            options = options || {};

            this.elementName = options.elementName;
            
            BaseView.prototype.initialize(this, options);
        },
        
        render: function(){

            this.$el.html(this.template());

            return this;
        },

        goToConsumerLanding: function(){
            pf.navigate('loyalty');
        },

        goToEnterpriseLanding: function(){
            pf.navigate('enterprise');
        },

        close: function(){}

    });
});
